import { useApi } from './api.mjs';
import { useSubscription } from './subscription.mjs';

/**
 * Returns the cart instructions used to create the checkout and possibly limit extension capabilities.
 */
function useInstructions() {
  return useSubscription(useApi().instructions);
}

export { useInstructions };
